import { TranslatePipe } from './../../shared/pipes/translate.pipe';
import { Injectable, Inject, EventEmitter } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { SessionService } from './session.service';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';
import { DomainService } from './domain.service';

@Injectable()
export class RequestService {

    constructor(
        private http: Http,
        private router: Router,
        private sessionService: SessionService,
        private authService: AuthService,
        private notificationService: NotificationService,
        private domainService: DomainService,
        private translate: TranslatePipe
    ) { }

    public get(url: string, query?: any, responseType?: any, suppressError?: boolean) {
        let options = {
            headers: this.prepareHeaders()
        }

        if (query) {
            let search = new URLSearchParams();

            Object.keys(query).forEach(function (key) {
                search.set(key, query[key])
            });

            options['search'] = search;
        }

        if (responseType) {
            switch (responseType) {
                case 'text':
                    options['responseType'] = ResponseContentType.Text;
                    break;
                case 'json':
                    options['responseType'] = ResponseContentType.Json;
                    break;
                case 'blob':
                    options['responseType'] = ResponseContentType.Blob;
                    break;
                default:
                    throw responseType + ' not a valid option'
            }
        }

        let requestOptions = new RequestOptions(options);
        let response = this.http.get(url, requestOptions)
            .map(r => this.extractData(r));

        if (!suppressError) {
            response = response.catch(e => this.handleError(e));
        }

        return response;
    }

  public getWithoutXitpxDomain(url: string, responseType?: any, suppressError?: boolean, filename?: string) {
    let options = {
      headers: this.prepareHeadersWihoutXitpx()
    }

    if (responseType) {
      switch (responseType) {
        case 'text':
          options['responseType'] = ResponseContentType.Text;
          break;
        case 'json':
          options['responseType'] = ResponseContentType.Json;
          break;
        case 'blob':
          options['responseType'] = ResponseContentType.Blob;
          break;
        default:
          throw responseType + ' not a valid option'
      }
    }

    let requestOptions = new RequestOptions(options);
    let response = this.http.get(url, requestOptions)
      .map(r => this.extractData(r, filename));

    if (!suppressError) {
      response = response.catch(e => this.handleError(e));
    }

    return response;
  }

    public post(url: string, body: any, suppressError?: boolean) {
        let headers = this.prepareHeaders();
        let requestOptions = new RequestOptions({ headers: headers });

        let response = this.http.post(url, body, requestOptions)
            .map(response => this.extractData(response));

        if (!suppressError) {
            response = response.catch(err => this.handleError(err));
        }

        return response;
    }

    private prepareHeadersWihoutXitpx(): Headers {
      let headers = this.domainService.getBaseHeadersWithoutXitpx();
      
      if (this.sessionService.getToken()) {
        headers.set('Authorization', 'Bearer ' + this.sessionService.getToken());
      }

      return headers;
    }

    private prepareHeaders(): Headers {
        let headers = this.domainService.getBaseHeaders();

        if (this.sessionService.getToken()) {
          headers.set('Authorization', 'Bearer ' + this.sessionService.getToken());
        }

        return headers;
    }

    private extractData(res: Response, filename?: string) {
        let body;
        if (res.headers.get('content-disposition') || res.headers.get('content-type') == 'application/pdf') {
            this.handleFileResponse(res, filename);
        } else {
            body = res.json();
        }

        return body;
    }

    private handleFileResponse(res: Response, filename: string = 'file.pdf') {
      let url= window.URL.createObjectURL(res.blob());
      let linkElement = document.createElement('a');
      try {
        linkElement.setAttribute('href', url);
        linkElement.setAttribute('download', filename);

        let clickEvent = new MouseEvent('click', {
          'view': window,
          'bubbles': true,
          'cancelable': false
        });
        linkElement.dispatchEvent(clickEvent);
      } catch (ex) {
        console.log(ex);
      }
      window.URL.revokeObjectURL(url);
      linkElement.remove();
        // let content = res.blob();
        // let filename = res.headers.get('content-disposition')
        //     .split('; filename=\"')[1]
        //     .slice(0, -1);

        // let type = res.headers.get('content-type');

        // var blob = new Blob([content], { type: type });
        // saveAs(blob, filename);
    }

    private handleError(err: any) {
        switch (err.status) {
            case 401: return this.forceLogout(err);
            case 409: return this.forceLogout(err);
            default: return this.returnError(err);
        }
    }

    private forceLogout(err) {
        this.authService.logout();

        return this.returnError(err);
    }

    private formatErrorMessage(resp) {
        resp = resp.json();
        let error = resp.error || resp;
        let message = (error.message) ? error.message : 'Server error';
        return this.translate.transform(message)
    }

    private returnError(err) {
        this.notificationService.error(this.formatErrorMessage(err), 'Failed');
        return Observable.throw(err)
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/request.service.ts